import { getParentsLinkElements } from '../dpitUtilsPublic';
import EventListeners from './EventListeners';

export default class ExclusiveClickListener {
	/**
	 * Init module for adjusting a click events, so only first event is captured and rest possibly registered events are suppressed 
	 *
	 * @param {Function} functionRef to run while event occurs
	 * @param {Boolean} stopPropagationEnabled should be propagation of click events stopped
	 * @param {Boolean} leftButtonOnly only left mouse button is captured
	 */
	constructor(functionRef, stopPropagationEnabled = true, disableAllPointerEvents = true, suppressParentsLinkElements = false, excludeTargetBlank = false, leftButtonOnly = true) {
		this.data = [];
		this.noEventTimeoutAfterVeryFirstClickMs = 1000;
		this.stopPropagationEnabled = stopPropagationEnabled;
		this.leftButtonOnly = leftButtonOnly;
		this.excludeTargetBlank = excludeTargetBlank;
		this.disableAllPointerEvents = disableAllPointerEvents;
		this.suppressParentsLinkElements = suppressParentsLinkElements;
		this.listeners = new EventListeners();
		this.functionRef = functionRef;
	}
	/**
	 * Subscribe element click events so only first event is captured and rest possibly registered events are suppressed 
	 *
	 * @param {HTMLCollection|Array} elements element or elements, where subscribe exclusive click
	*/
	addElements(elements) {
		if (elements) {
			elements.forEach((element) => this.addElement(element));
		}
	}

	addElement(element) {
		if (element) {
			const dataItem = {
				element: element,
				noEventsData: null
			};
			this.data.push = dataItem;
			this.listeners.add(element, 'mousedown', (event) => this.handleVeryFirstClickEvent(event, dataItem));
			this.listeners.add(element, 'touchstart', (event) => this.handleVeryFirstClickEvent(event, dataItem));
			this.listeners.add(element, 'click', (event) => this.handleFollowingClickEvents(event, dataItem));
			this.listeners.add(element, 'mouseup', (event) => this.handleFollowingClickEvents(event, dataItem));
			this.listeners.add(element, 'touchend', (event) => this.handleFollowingClickEvents(event, dataItem));
		}
	}

	/**
	 * Unsubscribe all subscribed events and clear pointer-events modification
	 * @param {Element} element element to unsubscribe
	*/
	clear(immediate = false) {

		if (immediate) {
			this.data.forEach(this.clearNoEvents.bind(this));
		}
		else {
			const dataBkp = [...this.data];
			setTimeout(() => {
				dataBkp.forEach(this.clearNoEvents.bind(this));
			}, this.noEventTimeoutAfterVeryFirstClickMs);
		}

		this.data = [];
		this.listeners.removeAll();
	}

	activateAfterClear() {
		setTimeout(() => {
			this.clear(true);
		}, this.noEventTimeoutAfterVeryFirstClickMs);
	}

	isLeftClickEvent(event) {
		if (!this.leftButtonOnly) return true;
		return event.button === 0;
	}

	handleVeryFirstClickEvent(event, dataItem) {
		let res = true;
		if (this.isLeftClickEvent(event)) {
			res = false;
			//console.log('handleFollowingClickEvents sssssssssssssssssssssssssssssssssssssssssssssssssssssss', event.type, event);
			if (this.functionRef instanceof Function) {
				res = this.functionRef(event, dataItem.element);
			}
			if (!res) {
				if (this.stopPropagationEnabled) event.stopImmediatePropagation();
				this.activateNoEvents(dataItem);
			}
		}
		return res;
	}

	handleFollowingClickEvents(event, dataItem) {
		//console.log('handleFollowingClickEvents sssssssssssssssssssssssssssssssssssssssssssssssssssssss', event.type, event);
		if (this.isLeftClickEvent(event)) {
			if (event.type === 'click') event.preventDefault();
			if (this.stopPropagationEnabled) {
				event.stopImmediatePropagation();
			}
			this.activateNoEvents(dataItem);
			return false;
		}
		return true;
	}

	startNoEventTimeout(dataItem, onCleared) {
		if (dataItem.noEventsTimeout) clearTimeout(dataItem.noEventsTimeout);
		dataItem.noEventsTimeout = setTimeout(() => {
			this.clearNoEvents(dataItem);
			if (onCleared instanceof Function) onCleared(dataItem.element);
		}, this.noEventTimeoutAfterVeryFirstClickMs);
	}

	activateNoEvents(dataItem) {
		if (this.disableAllPointerEvents) {
			if (!dataItem.noEventsData) {
				let noEventElements = [dataItem.element];
				if (this.suppressParentsLinkElements) {
					noEventElements = getParentsLinkElements(dataItem.element, true, this.excludeTargetBlank);
				}
				noEventElements.forEach((element) => this.addElementNoEvents(dataItem, element));
				this.startNoEventTimeout(dataItem);
			} else {
				this.startNoEventTimeout(dataItem);
			}
		}

	}

	addElementNoEvents(dataItem, element) {
		if (dataItem && element) {
			const pointerEventsProp = element.style.getPropertyValue('pointer-events');
			element.style.setProperty('pointer-events', 'none', 'important');
			if (!dataItem.noEventsData) dataItem.noEventsData = [];
			dataItem.noEventsData.push({
				element,
				pointerEventsBkp: pointerEventsProp
			});
		}
	}

	clearNoEvents(dataItem) {
		if (dataItem.noEventsData) {
			dataItem.noEventsData.forEach(this.clearNoEventsOnNoEventsItem.bind(this));
			if (dataItem.noEventsTimeout) clearTimeout(dataItem.noEventsTimeout);
			dataItem.noEventsTimeout = null;
		}
		dataItem.noEventsData = null;
	}

	clearNoEventsOnNoEventsItem(noEventsDataItem) {
		if (noEventsDataItem?.element) {
			if (noEventsDataItem.pointerEventsBkp) {
				noEventsDataItem.element.style.setProperty('pointer-events', noEventsDataItem.pointerEventsBkp);
			}
			else noEventsDataItem.element.style.removeProperty('pointer-events');
		}
	}

}